import React from 'react';
import classNames from 'classnames';
import Link from '../ui/link/Link';
import styles from './link.scss';

const HeaderLink = props => (
  <Link
    {...props}
    itemClassName={styles.headerLinkItem}
    anchorClassName={classNames(styles.headerLink, {
      [styles.headerLink__bp]: props.isBrandPromiseActive,
      [styles.headerLink__threshold]: props.isThresholdActive,
    })}
  />
);

export default HeaderLink;
